import React, { useContext } from 'react';
import { constructUrl } from '../../../utils/UrlConstructor';
import { withTranslation } from 'react-i18next';
import { formatPriceString } from '../modals/product/extended-product-modal/util/ProductModalHelpers';

import './CartItem.css'
import { AddToCartContext } from './AddToCartContext';

const CartItem = ({ sku, name, size, pricePrefix,isCartDropDown, price, thumbnail, menuTextFontStyle, prefix, removeFromCart, quantity, currentLanguage, width, color, t }) => {
    const { addToCart, updateFromCart} = useContext(AddToCartContext);
    
    const increaseItemQuantity = () => {
        addToCart({
            SKU: sku,
            QTY: 1
        });
    }

    const decreaseItemQuantity = () => {
        if(quantity === 1){
            removeFromCart(sku);
        } else {            
            console.log('decreaseItemQuantity<<<')
            updateFromCart(sku);
        }
    }
    
    return (
        <React.Fragment>
            <div className='cart-item-container'>
                <div className='cart-item-row'>
                    <div className="cart-img">
                        {thumbnail && <img className='cart-item-thumbnail' src={thumbnail} />}
                        {!thumbnail && <div className='cart-item-thumbnail'>&nbsp;</div>}
                    </div>
                    <div className="cart-btns">
                        <div className='cart-item-info' style={menuTextFontStyle}>
                        <span className='cart-item-name'>{name.replace(/Salvatore Ferragamo Men |Salvatore Ferragamo Women /gi, "")}</span>
                            {color && <span className='cart-item-size'>Color: {color}</span>}
                            {size && <span className='cart-item-size'>{t('wishlistCartDropdown6')}: {size}</span>}
                            {width && <span className='cart-item-size'>{t('wishlistCartDropdown7')}: {width}</span>}
                        </div>
                    </div>
                </div>
                <div className='cart-item-row'>
                    <div className='cart-item-remove' onClick={() => removeFromCart(sku)}>{t('wishlistCartDropdown1')}</div>
                    {quantity && <div className="cart-qty">
                        <span className='cart-item-qty'>
                            {`${t('wishlistCartDropdown2')}:`} 
                            { isCartDropDown && <span className='decrease-quantity' onClick={decreaseItemQuantity}> -</span>}
                                {quantity} 
                            { isCartDropDown && <span className='increase-quantity' onClick={increaseItemQuantity}>+</span>}
                        </span>
                    </div>}
                    {price && <div className='cart-item-price'>
                        <span className='cart-item-price'>
                            {formatPriceString(((quantity ? quantity : 1) * price), currentLanguage)}</span>
                    </div>}
                </div>
            </div>
            <hr className="cart-item-break" />
        </React.Fragment>
    )
}

export default withTranslation()(CartItem);
